export const buttonLight = {
  px: 's',
  height: '44px',
  minWidth: '100px',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'xl',
  borderColor: 'transparent',
  borderStyle: 'solid',
  cursor: 'pointer',
  outline: 'none !important',
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  fontSize: 'xs',
  variants: {
    primary: {
      textAlign: 'center',
      backgroundColor: 'primary',
      borderStyle: 'none',
      color: 'white',
      fontFamily: 'regular',
      fontSize: 'm',
      fontWeight: 'medium',
      states: {
        '&:disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
        },
      },
    },
    error: {
      textAlign: 'center',
      backgroundColor: 'error',
      borderStyle: 'none',
      color: 'white',
      fontFamily: 'regular',
      fontWeight: 'medium',
      fontSize: 'm',
      states: {
        '&:disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
        },
      },
    },
    positive: {
      textAlign: 'center',
      backgroundColor: 'primary/text',
      borderStyle: 'none',
      color: 'white',
      fontFamily: 'regular',
      fontSize: 's',
      fontWeight: 'medium',
      states: {
        '&:disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
        },
      },
    },
    gradient: {
      textAlign: 'center',
      bgGradient: 'primary',
      borderStyle: 'none',
      color: 'white',
      fontFamily: 'regular',
      fontWeight: 'medium',
      states: {
        '&:disabled': {
          opacity: 0.5,
          cursor: 'not-allowed',
        },
      },
    },
    'link/primary': {
      color: 'primary/text',
      fontFamily: 'regular',
      fontSize: 'm',
      lineHeight: 'm',
      px: 'none',
      minWidth: 'none',
      borderRadius: 'none',
      borderColor: 'none',
      borderStyle: 'none',
      bg: 'transparent',
      textDecoration: 'underline',
      states: {
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
  },
};
